import React from 'react';

const InsightsLoader = () => {
  return (
    <div className="section-loader loading center-align">
      <ul className="loading-dots">
        <li />
        <li />
        <li />
      </ul>
    </div>
  );
};

export default InsightsLoader;
